import {  Table } from "antd";
import styled from "styled-components";

export const StyledTable = styled(Table)`
  width: 65%;
  .ant-table-content {
    margin-top: 16px;
  }

  .ant-table-header {
    border: 1px solid #e2e7ee !important;
  }

  .ant-table-container {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    box-shadow: inset 1px 0px 0px #e2e7ee, inset -1px 0px 0px #e2e7ee,
      inset 0px 1px 0px #e2e7ee, inset 0px -1px 0px #e2e7ee;
  }

  .ant-table-thead .ant-table-cell {
    padding: 9px 12px;
    font-size: 14px;
    font-weight: 600;
    background-color: #f7f9fe;
    color: #4a5368;
  }

  && .ant-table-cell::before {
    background-color: #f7f9fe !important;
  }

  && .ant-table-cell {
    border-bottom: 1px solid #e2e7ee;
    padding: 8px 12px;
  }

  .ant-table-body::-webkit-scrollbar {
    width: 0;
  }
`;
